Apt.fn.make('creator', {
	/**
	 * Initialize module
	 */
	init: function() {
		var priv = this.$private,
			uri = $.routes.uri(),
			step = uri.hash || 'style';

		priv.data = {
			style: uri.query.style || null,
			spout: uri.query.spout || $$('creatorRender').data('id'),
			handles: uri.query.handles || null,
			finish: uri.query.finish || 1237
		}

		priv.mapOptions();
		priv.filter();

		priv.initNav();
		priv.initStatus();

		if (priv.data.spout) {
			$.fetch.request({
				url: '/api/v1/creator/' + priv.data.spout,
				json: true,
				success: function(data) {
					priv.variants = data.data;
					
					// Update UI without replacing URL
					priv.update(false);
					
					// If we have URL parameters, activate the corresponding elements
					if (priv.data.style) {
						priv.activate($$('creatorStyle').filter('[data-value="' + priv.data.style + '"]'));
					}
					if (priv.data.handles) {
						priv.activate($$('creatorHandles').filter('[data-value="' + priv.data.handles + '"]'));
					}
					if (priv.data.finish) {
						priv.activate($$('creatorFinish').filter('[data-value="' + priv.data.finish + '"]'));
					}
					
					// Finally, move to the specified step
					priv.step(step);
				}
			});
			return;
		}

		// If no spout specified, just start at style step
		priv.step('style');
	},

	/**
	 * Unload module
	 */
	unload: function() {
		var scope = this;

		$.events.reset('creator');
		$.scroll.reset('creator');

		$$('creatorStatus').remove();

		if (scope.zoom) {
			scope.zoom.$destroy();

			delete scope.zoom;
		}
	}
}, {
	/**
	 * Map parameters to labels
	 */
	mapOptions: function() {
		var map = {
			spout: {},
			handles: {},
			finish: {}
		};

		Object.keys(map).forEach(function(option) {
			$$('creator' + option.charAt(0).toUpperCase() + option.slice(1)).each(function(el) {
				map[option][el.dataset.value] = el.dataset.label;
			});
		});

		this.map = map;
	},

	/**
	 * Filter based on style
	 */
	filter: function() {
		var style = this.data.style,
			$options = $('ref:creatorSpout, ref:creatorHandles'),
			hiddenClass = '-is-hidden';

		$options.removeClass(hiddenClass);

		if (style) {
			$options.filter(':not([data-style*="' + style + '"])')
				.addClass(hiddenClass);
		}
	},

	/**
	 * Initialize navigation
	 */
	initNav: function() {
		var scope = this;

		$$('creatorNav').on('click', function(e, el) {
			scope.step(el.dataset.target);
		}, {
			namespace: 'creator'
		});
	},

	/**
	 * Initialize status bar
	 */
	initStatus: function() {
		var scope = this,
			$status = $$('creatorStatus'),
			lockedClass = '-is-locked';

		$.scroll.map([
			{
				target: 'ref:footer',
				callback: function() {
					$status.appendTo('ref:footer')
						.addClass(lockedClass);
				}
			},
			{
				target: 'ref:footer',
				threshold: -1,
				callback: function() {
					$status.removeClass(lockedClass);
				}
			}
		], {
			namespace: 'product'
		});

		$$('creatorShare').on('click', function() {
			var id = $$('modelValue').data('id');

			scope.share = Apt.fn.share()
				.init({
					target: 'product',
					id: id
				});
		}, {
			namespace: 'creator'
		});

		$$('creatorWishlist').on('click', function() {
			var id = $$('modelValue').data('id'),
				$el = $(this);

			// Check if user is logged in
			if (Apt.wishlists.$get('userId')) {
				// For logged-in users, show the selection modal
				Apt.wishlists.prompt(id, function(state) {
					$el.toggleClass('-is-active', state);
				});
			} else {
				// For guest users, directly toggle the wishlist item
				Apt.wishlists.toggle(id, null, function(state) {
					$el.toggleClass('-is-active', state);

					if ($('.wishlist-container').length > 0) {
						window.location.reload();
					}
				});
			}
		}, {
			namespace: 'product'
		});
	},

	/**
	 * Replace URL with parameters
	 *
	 * @param {Boolean} [replace=true]
	 */
	update: function(replace) {
		var scope = this,
			query = [
				'style',
				'spout',
				'handles',
				'finish'
			],
			params = [],
			options = {},
			append = '';

		query.forEach(function(param) {
			var value = scope.data[param];

			if (value) {
				value = isNaN(value) ?
					value : Number(value);

				scope.data[param] = value;

				params.push(param + '=' + value);

				if (param !== 'style') {
					options[param] = scope.map[param][value];
				}
			}
		});

		if (params.length) {
			if (options.spout && ! options.handles) {
				options.handles = options.spout;
			}

			if (scope.variants) {
				var base = scope.variants.find(function(variant) {
					return variant.base;
				}) || scope.variants[0];

				scope.data.handles = scope.data.handles || base.handles;
				scope.data.finish = scope.data.finish || base.finish;
			}

			Object.keys(options).forEach(function(param) {
				$$(param + 'Value').text(options[param]);
			});

			append = params.join('&');
		}

		if (replace !== false) {
			if (append) {
				append = '?' + append;
			}

			if (scope.data.step) {
				append += '#' + scope.data.step;
			}

			$.history.replace($.routes.uri().path + append);
		}

		scope.render();
	},

	/**
	 * Render product
	 */
	render: function() {
		var scope = this,
			$image = $$('creatorImage');

		if (scope.zoom) {
			scope.zoom.restore();
		}

		if (scope.variants) {
			var match = scope.variants.find(function(variant) {
				return variant.finish === scope.data.finish &&
					variant.handles === scope.data.handles
			});

			if (! match) {
				return;
			}

			$$('modelValue').text(match.sku)
				.data('id', match.id);

			$image.attr('src', match.image);
		}

		if (scope.zoom) {
			return;
		}

		scope.zoom = Apt.fn.zoom()
			.init({
				container: 'ref:creatorRender',
				image: $image,
				size: 'Medium'
			});
	},

	/**
	 * Initialize step
	 *
	 * @param {String} step
	 */
	step: function(step) {
		var scope = this,
			$target = $$(step + 'Step'),
			prev = scope.data.step;

		scope.data.step = step;

		$$('creatorDetail').toggleClass('-is-active', step !== 'style');

		if (prev) {
			scope.update();

			$.animate.tween($._body, {
				scrollTop: $$('creator').offset().top
			});
		}

		if ($$('creatorProgress').length) {
			scope.activate(
				$$('creatorProgress').find('ref:creatorNav')
					.filter('[data-target=' + step + ']')
			);
		}

		if ($target.length) {
			scope.activate($target);
			
			$$('creatorHeading').text(
				$target.data('title') || ''
			);
		}

		if (typeof scope[step] === 'function') {
			scope[step]();
		}

		scope.cycle(step);
	},

	/**
	 * Initialize cycle
	 *
	 * @param {String} step
	 */
	cycle: function(step) {
		var option = step.charAt(0).toUpperCase() + step.slice(1),
			$options = $$('creator' + option).filter(':not(.-is-hidden)');

		$$('creatorCycle').off('click')
			.on('click', function(e, el) {
				var active = $options.filter('.-is-active')[0],
					match;

				if (! active) {
					match = $options.first()[0];
				}

				if (! match && el.dataset.target === 'next') {
					var next = active && active.nextElementSibling;

					while (next) {
						if (! next.dataset || ! next.dataset.value) {
							break;
						}

						if (! next.classList.contains('-is-hidden')) {
							match = next;
							break;
						}

						next = next.nextElementSibling;
					}

					if (! match) {
						match = $options.first()[0];
					}
				} else if (! match) {
					var prev = active && active.previousElementSibling;

					while (prev) {
						if (! prev.classList.contains('-is-hidden')) {
							match = prev;
							break;
						}

						prev = prev.previousElementSibling;
					}

					if (! match) {
						match = $options.last()[0];
					}
				}

				if (match && match.parentNode) {
					match.parentNode.scrollTo({
						left: match.offsetLeft - 68,
						behavior: 'smooth'
					});

					$(match).trigger('click');
				}
			}, {
				namespace: 'creator'
			});
	},

	/**
	 * Activate element
	 *
	 * @param {$} target
	 */
	activate: function(target) {
		var activeClass = '-is-active';

		$(target).addClass(activeClass)
			.siblings()
			.removeClass(activeClass);
	},

	/**
	 * Initialize style step
	 */
	style: function() {
		var scope = this;

		$$('creatorStyle').on('click', function(e, el) {
			scope.data.style = el.dataset.value || null;

			scope.filter();

			scope.step('spout');
		}, {
			namespace: 'creator'
		});
	},

	/**
	 * Initialize spout step
	 */
	spout: function() {
		var scope = this;
		
		try {
			// First, remove any existing click handlers to prevent duplicates
			$$('creatorSpout').off('click', { namespace: 'creator' });
			
			// Then add new click handlers with proper error checking
			$$('creatorSpout').on('click', function(e, el) {
				try {
					// Validate element exists
					if (!el) {
						console.warn('Creator: Spout element is undefined');
						return;
					}
					
					// Validate dataset exists
					if (!el.dataset) {
						console.warn('Creator: Spout element dataset is undefined');
						return;
					}
					
					var $el = $(el);
					var value = el.dataset.value;
					
					// Safely get data attributes with fallbacks
					var style = ($el.data('style') || []).slice();  // Create a copy to avoid reference issues
					var handles = ($el.data('handles') || []).slice();
					
					// Update data
					scope.data.spout = value;
					scope.data.handles = null;
					
					// Fetch data with proper error handling
					$.fetch.request({
						url: '/api/v1/creator/' + value,
						json: true,
						success: function(data) {
							try {
								// Validate response data
								if (!data || !data.data) {
									console.warn('Creator: Invalid response data for spout', value);
									return;
								}
								
								scope.variants = data.data;
								
								var values = {};
								var $options = $$('creatorHandles');
								var hiddenClass = '-is-hidden';
								
								// Reset all options to hidden state
								if ($options && $options.length) {
									$options.addClass(hiddenClass);
									
									// Process variants to determine which handles to show
									if (Array.isArray(scope.variants)) {
										scope.variants.forEach(function(variant) {
											if (!variant || typeof variant.handles === 'undefined') return;
											
											// Skip if handles don't match filter
											if (Array.isArray(handles) && handles.length && 
												!handles.includes(variant.handles.toString())) {
												return;
											}
											
											values[variant.handles] = true;
										});
										
										// Show matching handle options
										Object.keys(values).forEach(function(value) {
											if (!style || !style.length) return;
											
											var styleSelector = '[data-style*="' + style[0] + '"]';
											var valueSelector = '[data-value="' + value + '"]';
											
											$options.filter(valueSelector)
												   .filter(styleSelector)
												   .removeClass(hiddenClass);
										});
									}
								}
								
								// Activate the selected element and update UI
								scope.activate(el);
								scope.update();
							} catch (innerErr) {
								console.error('Creator: Error processing spout data', innerErr);
							}
						},
						error: function(xhr, status, error) {
							console.error('Creator: Failed to fetch data for spout', value, error);
						}
					});
				} catch (clickErr) {
					console.error('Creator: Error in spout click handler', clickErr);
				}
			}, {
				namespace: 'creator'
			});
			
			// Find and trigger appropriate spout
			try {
				var $spouts = $$('creatorSpout');
				
				if (!$spouts || !$spouts.length) {
					console.warn('Creator: No spout elements found');
					return;
				}
				
				// Find matching spout based on URL parameter with thorough validation
				var $visibleSpouts = $spouts.filter(':not(.-is-hidden)');
				var $matchingSpout = $visibleSpouts.filter(function(el) {
					return el && el.dataset && 
						   typeof el.dataset.value !== 'undefined' && 
						   el.dataset.value === scope.data.spout;
				}).first();
				
				// If no matching spout found, use first visible spout
				if (!$matchingSpout || !$matchingSpout.length) {
					$matchingSpout = $visibleSpouts.first();
				}
				
				// Trigger click on the selected spout with validation
				if ($matchingSpout && $matchingSpout.length && $matchingSpout[0]) {
					$matchingSpout.trigger('click');
				} else {
					console.warn('Creator: No valid spout element to activate');
				}
			} catch (spoutErr) {
				console.error('Creator: Error finding/triggering spout', spoutErr);
			}
		} catch (err) {
			console.error('Creator: Fatal error in spout initialization', err);
		}
	},

	/**
	 * Initialize handles step
	 */
	handles: function() {
		var scope = this;

		$$('creatorHandles').on('click', function(e, el) {
			if (el && el.dataset) {
				scope.data.handles = el.dataset.value;
				scope.activate(el);
				scope.update();
			}
		}, {
			namespace: 'creator'
		});
	},

	/**
	 * Initialize finish step
	 */
	finish: function() {
		var scope = this;

		$$('creatorFinish').on('click', function(e, el) {
			if (el && el.dataset) {
				scope.data.finish = el.dataset.value;
				scope.activate(el);
				scope.update();
			}
		}, {
			namespace: 'creator'
		});
	}
});